const renewalDetailsFormatter = (data, renewalData) => {

  const dataSet = data;
  console.log(data, "data")
  dataSet["reporting_manager_id"] = data?.manager?.id||data?.manager
  return dataSet;
};

  export default renewalDetailsFormatter;
  